import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState, useEffect, useReducer, useRef } from "react";
import PrimaryButton from "../../../../../common/crunches/primaryButton/primaryButton.js";
import { DataFetchReducers } from "../../../../../common/states/dataFetch/dataFetchReducers.js";
import { dataFetchActionType } from "../../../../../common/states/dataFetch/dataFetchActionType.js";
import Image from "react-bootstrap/Image";
import PencilLineIcon from "remixicon-react/PencilLineIcon";
import CloseLineIcon from "remixicon-react/CloseLineIcon";
import ImageAddLineIcon from "remixicon-react/ImageAddLineIcon";
import { uploadImage } from "../../../../../common/components/uploadImage/uploadImage.js";

export default function AddProductCategoryModal(props) {
  let productCategoryDetails = props.value.productCategoryDetails;

  const inputRef = useRef(null);
  const [productCatName, setProductCatName] = useState("");
  const [categoryDesc, setCategoryDesc] = useState("");
  const [productImage, setProductImage] = useState([]);
  const [showButton, setShowButton] = useState(true);
  const [uploadStatus, dispatchUploadStatus] = useReducer(DataFetchReducers, {
    data: null,
    loading: false,
    error: null,
  });

  useEffect(() => {
    if (props.value.isEdit) {
      setShowButton(false);
      setProductCatName(productCategoryDetails?.name);
      setCategoryDesc(productCategoryDetails?.description);

      setProductImage(
        productCategoryDetails?.images ? productCategoryDetails?.images : []
      );
    } else {
      setShowButton(true);
    }
  }, [props.value.show]);

  const handleUpload = () => {
    inputRef.current?.click();
  };

  const uploadImages = async () => {
    const folderPath = "product-categories";
    uploadImage(inputRef, setProductImage, dispatchUploadStatus, folderPath);
  };

  const onCloseModal = () => {
    setProductCatName("");
    setCategoryDesc("");
    setProductImage([]);
    dispatchUploadStatus({
      type: dataFetchActionType.data,
      data: null,
    });
    setShowButton(false);
    props.value.onHide();
    props.value.removeEdit();
  };

  return (
    <Modal
      show={props.value.show}
      onHide={onCloseModal}
      style={{ marginTop: "150px" }}
    >
      <Modal.Header closeButton style={{ border: "none" }}>
        <Modal.Title className="boldFont">
          <span className="modalHeading">
            {props.value.isEdit
              ? "Edit Product Category Details"
              : "New Product Category Details"}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          if (props.value.isEdit) {
            props.value.onEditModal({
              name: productCatName,
              description: categoryDesc,
              images: productImage,
            });
          } else {
            props.value.onSubmitModal({
              name: productCatName,
              description: categoryDesc,
              images: productImage,
            });
          }
          onCloseModal();
        }}
      >
        <Modal.Body>
          <Form.Floating className="mb-3">
            <Form.Control
              onFocus={() => setShowButton(true)}
              defaultValue={productCatName}
              onChange={(e) => setProductCatName(e.target.value)}
              placeholder="Product Category Name"
              required
            />
            <label
              htmlFor="floatingInputCustom"
              style={{ color: "#7D7676", width: "115%" }}
            >
              Product Category Name
              {props.value.isEdit ? (
                <PencilLineIcon style={{ float: "right", marginTop: "13px" }} />
              ) : null}
            </label>
          </Form.Floating>
          <Form.Floating className="mb-3">
            <Form.Control
              onFocus={() => setShowButton(true)}
              defaultValue={categoryDesc}
              onChange={(e) => setCategoryDesc(e.target.value)}
              placeholder="Category Description"
              required
            />
            <label
              htmlFor="floatingInputCustom"
              style={{ color: "#7D7676", width: "115%" }}
            >
              Category Description
              {props.value.isEdit ? (
                <PencilLineIcon style={{ float: "right", marginTop: "13px" }} />
              ) : null}
            </label>
          </Form.Floating>
          <div
            style={{
              border: "1px solid #dadada",
              borderRadius: "7px",
              padding: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <input
              onClick={() => setShowButton(true)}
              ref={inputRef}
              onChange={uploadImages}
              className="d-none"
              type="file"
            />
            {uploadStatus.data || productImage.length != 0 ? (
              <div>
                <div
                  onClick={() => {
                    setShowButton(true);
                    setProductImage([]);
                    dispatchUploadStatus({
                      type: dataFetchActionType.data,
                      data: null,
                    });
                  }}
                  style={{
                    marginBottom: "-13px",
                    zIndex: 10,
                    padding: "2.5px",
                    borderRadius: "50px",
                    background: "#dadada",
                    float: "right",
                    width: "30px",
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  <CloseLineIcon size={16} style={{ marginBottom: "7px" }} />
                </div>
                <div>
                  <Image
                    onClick={handleUpload}
                    src={productImage[0]}
                    rounded
                    style={{
                      maxHeight: "100%",
                      width: "200px",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </div>
            ) : (
              <button
                style={{
                  border: "1px solid #dadada",
                  borderRadius: "10px",
                  padding: "10px",
                  background: "white",
                }}
                type="button"
                onClick={handleUpload}
                className="light"
              >
                {uploadStatus.loading ? (
                  <div>
                    <ImageAddLineIcon
                      style={{
                        marginRight: "10px",
                        marginBottom: "3px",
                        color: "#7D7676",
                      }}
                    />
                    Uploading...
                  </div>
                ) : (
                  <div style={{ color: "#7D7676" }}>
                    <ImageAddLineIcon
                      style={{
                        marginRight: "10px",
                        marginBottom: "3px",
                      }}
                    />
                    Upload Product Image
                  </div>
                )}
              </button>
            )}
          </div>
        </Modal.Body>

        {showButton ? (
          <Modal.Footer style={{ justifyContent: "center", border: "none" }}>
            <PrimaryButton
              value={{
                type: "submit",
                child: props.value.isEdit ? "Save Changes" : "Create Category",
                buttonStyle: "modalCTA",
              }}
            />
          </Modal.Footer>
        ) : null}
      </Form>
    </Modal>
  );
}
